(function autoCloseDetails() {
  /**
   * @param {Element} element
   * @param {string} attribute
   */
  function isEnabledForCurrentViewport(element, attribute) {
    const enabledOn = element.getAttribute(attribute);
    const currentViewport = window.innerWidth < 750 ? 'mobile' : 'desktop';

    return enabledOn?.includes(currentViewport);
  }

  document.addEventListener('click', function (event) {
    const detailsToClose = [...document.querySelectorAll('details[data-auto-close-details][open]')].filter(
      (element) => {
        return (
          isEnabledForCurrentViewport(element, 'data-auto-close-details') &&
          !(event.target instanceof Node && element.contains(event.target))
        );
      }
    );

    for (const detailsElement of detailsToClose) detailsElement.removeAttribute('open');
  });

  document.querySelectorAll('details[data-hover-details]').forEach((detailsElement) => {
    /** @type {number | undefined} */
    let closeTimer;

    detailsElement.addEventListener('pointerenter', function () {
      if (!isEnabledForCurrentViewport(detailsElement, 'data-hover-details')) return;

      window.clearTimeout(closeTimer);
      detailsElement.setAttribute('open', '');
    });

    detailsElement.addEventListener('pointerleave', function () {
      if (!isEnabledForCurrentViewport(detailsElement, 'data-hover-details')) return;

      closeTimer = window.setTimeout(() => detailsElement.removeAttribute('open'), 120);
    });
  });
})();
